// Text styles the recipe page, cooking layout and their parts share
// (design language: small labels, section headings, supporting text).
import type { CSSProperties } from "react";
import { COLORS, FONT_SIZE } from "../lib/constants";

export const smallLabel: CSSProperties = { fontSize: FONT_SIZE.xs, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase" };
export const sectionHeading: CSSProperties = { fontFamily: "var(--font-serif)", fontSize: FONT_SIZE.h2, fontWeight: 600, margin: 0, lineHeight: 1.2 };
export const supporting: CSSProperties = { fontSize: FONT_SIZE.sm, color: COLORS.soft };
